var $ = require('../../../jCube');

exports.controlParagraph = {

    build: function(_data) {
        return $.assign({}, _data, {
            tagName:     'p',
            subType: null,
            container: {
                className: 'fb-paragraph'
            },
            label:       null,
            innerHTML: _data.label || _data.value,
        });
    }
};
